import React from 'react';
import Grid from '@material-ui/core/Grid';
import ListItemText from '@material-ui/core/ListItemText';
import strings from 'strings';
import { When } from 'UI/components/atoms';

import InfoLabel from '../InfoLabel';

import { useStyles } from './MapEntityInfo.styled';

/**
 * @param {Object} props
 * @param {React.ReactNode} props.details
 * @param {string} props.detailsLabel
 * @param {React.ReactNode} [props.entityStatus]
 * @param {string} props.entitySubtitle
 * @param {string} props.entityTitle
 * @param {React.ReactNode} [props.lastActivityContent]
 */
export const MapEntityInfo = ({
  details,
  detailsLabel,
  entityStatus = null,
  entitySubtitle,
  entityTitle,
  lastActivityContent = null
}) => {
  const classes = useStyles();

  const detailsText = <span className={classes.itemDescription}>{details}</span>;

  const textProps = { className: classes.overlineLabel };

  return (
    <ListItemText
      primary={entityTitle}
      primaryTypographyProps={{ className: classes.itemTitle }}
      className={classes.itemContent}
      secondaryTypographyProps={{ component: 'div' }}
      secondary={
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <span className={classes.itemSubtitle}>{entitySubtitle}</span>
          </Grid>
          <When condition={details}>
            <Grid item xs={12}>
              <InfoLabel title={detailsLabel} description={detailsText} textProps={textProps} />
            </Grid>
          </When>
          <When condition={entityStatus}>
            <Grid item xs={12}>
              <InfoLabel
                title={strings.map.entityInfo.statusLabel}
                description={entityStatus}
                textProps={textProps}
              />
            </Grid>
          </When>
          <When condition={lastActivityContent}>
            <Grid item xs={12}>
              <InfoLabel
                title={strings.map.entityInfo.lastActivityLabel}
                description={lastActivityContent}
                textProps={textProps}
                variant="body2"
              />
            </Grid>
          </When>
        </Grid>
      }
    />
  );
};
